class ProductCard extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['url']
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    if (!this.els.swatch?.exists) return

    this.handleSwatchClick = this.handleSwatchClick.bind(this)
    this.listeners.add(this, 'click', this.handleSwatchClick)
  }

  async handleSwatchClick (event) {
    const clickedSwatch = event.target.closest(this.els.swatch.selector)
    if (!clickedSwatch) return

    const variantUrl = clickedSwatch.dataset.url

    this.els.swatch.elements?.forEach((el) => {
      el.removeAttribute('aria-current')
      el.removeAttribute('tabindex')
      if (el.dataset.url === variantUrl) {
        el.setAttribute('aria-current', 'true')
        el.setAttribute('tabindex', '-1')
      }
    })

    // Replace specific content
    const templateMedia = clickedSwatch.querySelector(
      'template[data-role="media"]',
    )
    const templateMediaHover = clickedSwatch.querySelector(
      'template[data-role="media-hover"]',
    )

    if (this.els.media?.exists) {
      this.els.media.element.innerHTML = templateMedia?.innerHTML || ''
    }

    // Set media-hover to blank if templateMediaHover is empty
    if (this.els?.['media-hover']?.exists) {
      this.els['media-hover'].elements.forEach((hoverEl) => {
        const hoverHtml = templateMediaHover?.innerHTML?.trim()

        if (hoverHtml) {
          hoverEl.innerHTML = hoverHtml
          hoverEl.hidden = false
        } else {
          hoverEl.innerHTML = ''
          hoverEl.hidden = true
        }
      })
    }

    // Replace URLs
    this.els.url.elements.forEach((urlEl) => {
      urlEl.href = variantUrl
    })
    this.els.media.elements.forEach((urlEl) => {
      urlEl.href = variantUrl
    })
    this.els['media-hover'].elements.forEach((urlEl) => {
      urlEl.href = variantUrl
    })

    // Replace quick view trigger URL
    this.els.quick?.elements?.forEach((quickEl) => {
      quickEl.dataset.productUrl = variantUrl
    })
  }
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard, { extends: 'article' })
}
